
import React, { Component } from 'react';
import { Modal, Row, Divider, Button, Table} from 'antd';
import http from '../../../axios/http';
import messager from '../../ui/messager';

class AuctionLotsDetail extends Component {
    columns = [{
        title: '旧车架号',
        dataIndex: 'oldVin',
        width: '15%',
    }
    ,{
        title: '新车架号',
        dataIndex: 'newVin',
        width: '15%',
    }
    , {
        title: '旧归属公司',
        dataIndex: 'oldProjectId',
        width: '15%',
    }
    , {
        title: '新归属公司',
        dataIndex: 'newProjectId',
        width: '15%',
    }
    , {
        title: '操作',
        dataIndex: 'typeStr',
        width: '10%',
    }
    , {
        title: '操作人',
        dataIndex: 'operator',
        width: '10%',
    }
    , {
        title: '创建时间',
        dataIndex: 'createTime',
        width: '10%',
    }
];
approve = (type) => {
    const { logs,successCallback,onCancel }=this.props;
    let id=logs[logs.length-1].id
    let t=1;
    if (type === "AGREE") {
        t=1;
    }else if(type === "REFUSE"){
        t=2;
    }else{
        messager.notify('未知审批类型');
    }
    http.post({
        url: "/barrier/batchVehicleLog/approve",
        data: { id: id,type:t },
        success: (res) => {
            this.setState({ loadingVisible: false });
            onCancel();
            messager.notify("审批成功！");
            successCallback();
        },
        error: (res) => {
            this.setState({ loadingVisible: false });
            messager.alert(res, "异常", "error");
        }
    });
};
    render() {
        const { visible, onCancel} = this.props;
        return (
            <Modal
                width={1000}
                visible={visible}
                title="账单详情"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="take" type="primary" onClick={this.approve.bind(this, "AGREE")}>通过</Button>,
                    <Button key="take" type="danger" onClick={this.approve.bind(this, "REFUSE")}>退回</Button>,
                    <Button key="take" type="default" onClick={onCancel}>关闭</Button>
                ]}
            >
                <Row>
                    <Divider orientation="left">账单详情列表</Divider>
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={this.props.logs}
                        pagination={{ pageSize: 10 }}
                        bordered={true}
                    />
                </Row>
            </Modal>
        );
    }
}


export default AuctionLotsDetail;